export default __webpack_public_path__ + "save-file-option.png";